<template>
  <footer
    class="form-fw__footer"
    :class="{ 'form-fw__footer--shadow': shadow }"
  >
    <div class="form-fw__footer__container py-2">
      <div v-if="kind === 'editar'" class="text-xs-right">
        <a
          v-if="status !== isLoading"
          href="#"
          :title="$t('Common.cancel')"
          class="accent--text mr-2"
          @click.prevent="cancel"
        >{{ $t('Common.cancel') }}</a>

        <v-btn
          :disabled="status === isLoading"
          :loading="status === isLoading"
          type="submit"
          color="accent"
          depressed
          round
          @click="submit"
        >
          {{ $t(`${namespace}.save`) }}
        </v-btn>
      </div>

      <div v-if="kind === 'cadastrar'" class="text-xs-right">
        <a
          v-if="status !== isLoading"
          href="#"
          :title="$t('Common.cancel')"
          class="accent--text mr-2"
          @click.prevent="cancel"
        >{{ $t('Common.cancel') }}</a>

        <v-btn
          :disabled="status === isLoading"
          :loading="status === isLoading"
          type="submit"
          color="accent"
          depressed
          round
          @click="submit"
        >
          {{ step === 1 ? $t(`${namespace}.nextStep`) : $t(`${namespace}.create`) }}
        </v-btn>
      </div>
    </div>

    <CancelDialog
      :visible="cancelDialog"
      @close="closeCancelDialog"
    />
  </footer>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { goBack } from '@/utils/functions'
import CancelDialog from './CancelDialog'

export default {
  name: 'Footer',
  props: {
    kind: {
      type: String
    },
    status: {
      type: Number
    },
    step: {
      type: Number,
      default: 1
    }
  },
  components: {
    CancelDialog
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED,
    routeName () {
      return this.$route.name
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyDataPage.footer',
      shadow: true,
      cancelDialog: false
    }
  },
  methods: {
    cancel () {
      if (this.routeName === 'CreateCompany') {
        this.openCancelDialog()
        return
      }

      goBack()
    },

    submit () {
      this.$emit('submit')
    },

    handleShadow () {
      this.shadow = !((window.innerHeight + window.scrollY) >= document.body.offsetHeight)
    },

    openCancelDialog () {
      this.cancelDialog = true
    },

    closeCancelDialog (redirect) {
      this.cancelDialog = false

      if (redirect) {
        this.$router.push({ name: 'Company' })
      }
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
